const QUOTE_REQUEST_TOPICS = Object.freeze({
  STD_PROJECT: 'PR',
  DATAROOM: 'DR',
  ELECTRONIC_SAFE: 'ES',
})

const QUOTE_REQUEST_TOPICS_ENDPOINTS = Object.freeze({
  PR: 'https://go.lexisnexis.fr/l/659013/2025-05-23/7w49xk',
  DR: 'https://go.lexisnexis.fr/l/659013/2025-05-20/7w3r7y',
  ES: 'https://go.lexisnexis.fr/l/659013/2025-05-23/7w49xr',
})

export { QUOTE_REQUEST_TOPICS, QUOTE_REQUEST_TOPICS_ENDPOINTS }
